module.exports = __webpack_public_path__ + "img/BE0416444061.cb3ad7ef.png";